import { Person } from "../../common";
import { TableData } from "../../components/Common/Table";
import { Investor } from "../../Investor";
import { getData, RawMedia } from "../adapter";

interface RawInvestor {
  id: number;
  attributes: {
    DualInfo: RawDualInfo;
    PeopleList: RawPeople[];
    bottomContent: string;
    topContent: string;
    calendar: TableData;
    cover: RawMedia;
    createdAt: Date;
    updatedAt: Date;
    ownerStructure: TableData;
    title: string;
  };
}

interface RawDualInfo {
  id: number;
  Column1: string;
  Column2: string;
}

interface RawPeople {
  title: string;
  people: {
    data: [
      {
        id: number;
        attributes: {
          name: string;
          jobTitle: string;
          info: string;
          image: RawMedia;
          createdAt: Date;
          updatedAt: Date;
        };
      }
    ];
  };
}

export const InvestorAdapter = async (
  rawJSON: RawInvestor
): Promise<Investor> => {
  const {
    id,
    attributes: { PeopleList, cover, createdAt, updatedAt, ...rest },
  } = await getData<RawInvestor>(rawJSON, "sv-SE");

  const newPeopleList = PeopleList.map(({ people, title }) => {
    const ppl: Person[] = people.data.map(
      ({ id, attributes: { image, createdAt, updatedAt, ...rest } }) => ({
        ...rest,
        id: id,
        created_at: createdAt,
        updated_at: updatedAt,
        image: image.data.attributes,
      })
    );
    return {
      title: title,
      people: ppl,
    };
  });

  const investor: Investor = {
    ...rest,
    cover: cover.data.attributes,
    PeopleList: newPeopleList,
    created_at: createdAt,
    updated_at: updatedAt,
    id: id,
  };

  return {
    ...investor,
  };
};
